<template>
    <div v-if="requisicao">
        <app-tabela
            :itens="requisicao.emailsEnvios"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
        </app-tabela>
    </div>
</template>

<script>
export default {
    props: {
        requisicao: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'dataEnvio',
                    label: 'Data de Envio',
                    sortable: true,
                    type: 'datetime',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'assunto',
                    label: 'Assunto',
                    filterable: true
                },
                {
                    key: 'destinatarios',
                    label: 'Destinatários',
                    filterable: true
                }
            ],
            itensPorPagina: 0
        }
    },

    methods: {},

    created() {},

    mounted() {},

    computed: {},

    watch: {},

    components: {}
}
</script>
